"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Integration_module_css_1 = __importDefault(require("../../Integration.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
// import TemplateVersionList from "../../Panel/TemplateVersionList";
var IntegrationStatsList_1 = __importDefault(require("../../Panel/IntegrationStatsList"));
var IntegrationJobHistory_1 = __importDefault(require("../../Panel/IntegrationJobHistory"));
var JobLogModal_1 = __importDefault(require("../../Panel/JobLogModal"));
var DataPreviewModal_1 = __importDefault(require("../../Panel/DataPreviewModal"));
var ImagePrviewModal_1 = __importDefault(require("../../Panel/ImagePrviewModal"));
var ResourceScriptStatusPanel_1 = __importDefault(require("./ResourceScriptStatusPanel"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
function getScriptItems(integration) {
    var definition = (integration === null || integration === void 0 ? void 0 : integration.definition) || { setup: { variables: {} }, scripts: {} };
    if (definition.scripts && Object.keys(definition.scripts).length > 0) {
        return definition.scripts;
    }
    if (definition.resources) {
        return definition.resources;
    }
    return {};
}
var IntegrationStatusTab = function (props) {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)([]), integrationJobs = _e[0], setIntegrationJobs = _e[1];
    var _f = (0, react_1.useState)(), currentScriptSelected = _f[0], setCurrentScriptSelected = _f[1];
    var _g = (0, react_1.useState)(), currentDataResourcePreview = _g[0], setCurrentDataResourcePreview = _g[1];
    var _h = (0, react_1.useState)(), currentImageResourcePreview = _h[0], setCurrentImageResourcePreview = _h[1];
    var pageProps = (0, useTypedPage_1.default)().props;
    var onScriptSelected = function (script) {
        setCurrentScriptSelected(script);
    };
    (0, react_1.useEffect)(function () {
        if (props.jobState) {
            var loadIntegrationJobs_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var jobs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, props.jobState.getIntegrationJobs()];
                        case 1:
                            jobs = _a.sent();
                            setIntegrationJobs(jobs);
                            return [2 /*return*/];
                    }
                });
            }); };
            props.jobState.onJobListChanged(function () {
                loadIntegrationJobs_1();
            });
            loadIntegrationJobs_1();
        }
    }, [props.jobState]);
    var scriptItems = getScriptItems(props.integration);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", paddingBottom: "50px" } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, (_a = props.integration) === null || _a === void 0 ? void 0 : _a.name),
                react_1.default.createElement("div", null, (_b = props.integrationTemplate) === null || _b === void 0 ? void 0 :
                    _b.description,
                    react_1.default.createElement("div", { style: { marginTop: "15px" } }, ((_c = props.integrationTemplate) === null || _c === void 0 ? void 0 : _c.description_link) && (react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { href: props.integrationTemplate.description_link, style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faGlobe, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px" } }),
                            t("Read more about the integration"))))))),
            react_1.default.createElement("div", { style: { width: "100px" } },
                react_1.default.createElement("img", { src: (_d = props.integrationTemplate) === null || _d === void 0 ? void 0 : _d.icon, style: { width: "100%" } }))),
        react_1.default.createElement("div", { className: Integration_module_css_1.default["section-row"] },
            react_1.default.createElement("div", { style: { width: "100%", paddingRight: "50px" } },
                react_1.default.createElement("div", { style: { marginTop: "20px" } },
                    react_1.default.createElement("div", null, Object.keys(scriptItems).map(function (identifier) {
                        var script = scriptItems[identifier];
                        return (react_1.default.createElement(ResourceScriptStatusPanel_1.default, { key: identifier, integration: props.integration, integrationTemplate: props.integrationTemplate, identifier: identifier, script: script, jobState: props.jobState, setCurrentImageResourcePreview: setCurrentImageResourcePreview, setCurrentDataResourcePreview: setCurrentDataResourcePreview, onScriptSelected: onScriptSelected }));
                    })))),
            react_1.default.createElement("div", { style: { width: "25%" } },
                pageProps.is_sysadmin && (react_1.default.createElement("div", null,
                    react_1.default.createElement(IntegrationStatsList_1.default, { integration: props.integration, integrationTemplate: props.integrationTemplate, jobState: props.jobState }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(IntegrationJobHistory_1.default, { integration: props.integration, integrationTemplate: props.integrationTemplate, integrationJobs: integrationJobs })))),
        currentScriptSelected && (react_1.default.createElement(JobLogModal_1.default, { integrationTemplate: props.integrationTemplate, integration: props.integration, jobState: props.jobState, script: currentScriptSelected, onClose: function () { return setCurrentScriptSelected(undefined); }, isShown: true })),
        currentDataResourcePreview && (react_1.default.createElement(DataPreviewModal_1.default, { integration: props.integration, resource: currentDataResourcePreview, onClose: function () { return setCurrentDataResourcePreview(undefined); }, isShown: true })),
        currentImageResourcePreview && (react_1.default.createElement(ImagePrviewModal_1.default, { integration: props.integration, resource: currentImageResourcePreview, onClose: function () { return setCurrentImageResourcePreview(undefined); }, isShown: true }))));
};
exports.default = IntegrationStatusTab;
